import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import './classes/UserTab.css';
import './classes/ViewTab.css';
import './classes/Modal.css';
import './classes/ViewApplicationProfile.css';
import Editor, { 
  BtnBold,
  BtnItalic,
  BtnRedo,
  BtnUndo,
  Toolbar
} from 'react-simple-wysiwyg';

import { configData } from "../config";
import EditProfile from './EditProfile';
import EditMentor from './EditMentor';
import EditAgent from './EditAgent';
import EditScout from './EditScout';
import EditAmbassador from './EditAmbassador';
import OrderPage from './OrderPage';
import ReferralPage from './ReferralPage';
import CertificatePage from './CertificatePage';
import ViewSalespersonDashboard from './ViewSalespersonDashboard';
import ViewSaadminDashboard from './ViewSaadminDashboard';
import ViewUserProfile from './ViewUserProfile';
import ViewApplicationProfile from './ViewApplicationProfile';
import AgentHome from './AgentHome';
import ScoutHome from './ScoutHome';
import Loading from './Loading';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';
import AgentBackendSidebar from './AgentBackendSidebar';
import ScoutSidebar from './ScoutSidebar';
import Select from 'react-dropdown-select';
import AdminEditProfile from './AdminEditProfile';
import ViewAgentProfile from './ViewAgentProfile';
import ViewAthleteProfile from './ViewAthleteProfile';
import ViewScoutProfile from './ViewScoutProfile';
import ViewAmbassadorProfile from './ViewAmbassadorProfile';
import ViewMentorProfile from './ViewMentorProfile';
import ApplicantSAAdminEditProfile from './ApplicantSAAdminEditProfile';
import ApplicantAdminEditProfile from './ApplicantAdminEditProfile';
import { Autocomplete, TextField, Button, Box  } from '@mui/material';

function ViewTab  ()  {
 
  const [toggle, setToggle] = useState(1);

  const [openDOC, setOpenDOC] = useState(false);
  const [docTalks, setDocTalks] = useState([]);
  const [search, setSearch] = useState("");

  const[userDetails,setUserDetails] = useState({});
  const[userAssets,setUserAssets] = useState({});
  
   const[userMentorAssets,setUserMentorAssets] = useState({});
   const[userSortflags,setUserSortflags] = useState({});
  const[userLoggedinDetails,setUserLoggedinDetails] = useState({});
  const[userAthleteAssets,setUserAthleteAssets] = useState({});
  const[userAgentAssets,setUserAgentAssets] = useState({});
  const[userScoutAssets,setUserScoutAssets] = useState({});
   const[userAmbassadorAssets,setUserAmbassadorAssets] = useState({});
  const[userSocailMediaAssets,setUserSocailMediaAssets] = useState({});
  const[userCommonAssets,setUserCommonAssets] = useState({});
  const[userLeadAssets,setUserLeadAssets] = useState({});
  const[userDoctalkAssets,setUserDocTalkAssets] = useState({});
  const[userEventAssets,setUserEventAssets] = useState({});
  
  const[userRoles,setUserRoles] = useState([]);
  const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
  // const[userOrderDetails,setUserOrderDetails] = useState({});
  const[userSlug,setUserSlug] = useState({});
  const[drupalUID,setDrupalUID] = useState({});
  const[certificateCount,setCertificateCount] = useState({});
  const[agentscoutstatus,setAgentScoutStatus] = useState([]);
  const[introemails,setIntroEmails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const[pageloadonteam,setIsPageLoadOnTeam] = useState(false);
  const[totalamount,setTotalAmount] = useState(0.0);
  const[success,setSuccess] = useState('');
  const editor_ref = React.useRef(null);
  const [IsSortFlagModalOpen, setIsSortFlagModalOpen] = useState(false);
  const[sortflagList, setSortflagList] = useState({});
  const[sortflagValue, setSortflagValue] = useState({});
  const[showIntroEmailModal, setShowIntroEmailModal] = useState(false);
  const [introemaildetailedview, setIntroEmailDetailedView] = useState({});
  const [productCount, setProductCount] = useState({});
   const [authorized, setAuthorized] = useState(
        !!localStorage.getItem("uid")
    );
  const excludedtoggle = [2,3,4,5,6,7,8,9,10]; // values you want to exclude
  const initialIntroEmailForm = {
      email:'',
      name:'',
      drupal_uid:'',
      course_code:'',
      subject:'',
      body:'',
      loggedin_user_email:'',
      loggedin_user_name:''

    };
    const [formIntroEmailData, setFormIntroEmailData] = useState(initialIntroEmailForm);


  const safeIntroEmails = Array.isArray(introemails) ? introemails : [];
  const ungrouped = safeIntroEmails.filter(item => item.name);
  const grouped = safeIntroEmails.filter(item => !item.name);

  const location  = useLocation();
  const drupal_uid = localStorage.getItem('drupal_uid');
  const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
   var loggedin_domain = drupal_domain_url;
  if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
  } 
  const { uid: paramUid, username } = useParams();

let uid = paramUid;

if (location.state?.userId) {
  uid = location.state.userId;
}
  /*var {uid} = useParams();
  console.log(uid+'Hai');
  var {username} = useParams();
  
 if(location.state) {
    const { userId } = location.state;
    uid = userId;
   
  } */
  const { slug } = useParams();

// useEffect(() => {
//   console.log("TAB");
//   console.log("pathname:", location.pathname);
//   console.log("isApplicationUser:", isApplicationUser);
//   console.log("toggle (state):", toggle);

//   const pathSegment = location.pathname.split("/").pop();
//   console.log("pathSegment:", pathSegment);

//   console.log("renderToggle (final):", renderToggle);
// }, [location.pathname, toggle, isApplicationUser, renderToggle]);

    // const successMessage =
    // location.state?.message && location.state.slug === slug
    //   ? location.state.message
    //   : null;
  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
    }
    
  const storedMessage = localStorage.getItem("invitesuccessMessage");
  if (storedMessage) {
    setSuccessMessage(storedMessage);
    localStorage.removeItem("invitesuccessMessage"); // show once
  }
  }, [location.state]);
  
  // const successMessage = location.state?.message; // Access the message
  const domainName = window.location.host.replace(/^https?:\/\//, '');
  const agencyDomains = [
    configData.RSMWW_AGENCY_DOMAIN,
    configData.RSMWW_AGENCY_DOMAIN1
  ];
  const scoutDomains = [
    configData.RSMWW_SCOUT_DOMAIN,
    configData.RSMWW_SCOUT_DOMAIN1,
    configData.RSMWW_SCOUT_DOMAIN2
  ];
  const mainDomains = [
    configData.RSMWW_DOMAIN,
  ];

  const {tab} = useParams();
  
  const loggedin_uid = localStorage.getItem('uid');
  const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
  const navigate = useNavigate();
  
  const app_url = configData.APP_URL;

  const domain_url = configData.DOMAIN_URL;
  const currentPath = location.pathname;

      const hiddenPaths = [
    "/user/"+drupalUID+"/certificate",   
  ];

  useEffect(() => {
        const checkLogout = (event) => {
            if (event.key === "uid") {

                const uid = localStorage.getItem("uid");

                if (!uid) {
                    setAuthorized(false);
                }
            }
        };

        window.addEventListener("storage", checkLogout);

        return () => {
            window.removeEventListener("storage", checkLogout);
        };
    }, []);
useEffect(() => {

    if (!authorized && tab !== 'certificate') {
        navigate("/user");
    }

}, [authorized]);
// if (!localStorage.getItem("uid")) {
//     navigate("/user");
// }
  let content;

  /* if (userRoles.includes(configData.ROLE_SALES_PEOPLE)) {
    content = <ViewSalespersonDashboard />;
  } else if (userRoles.includes(configData.ROLE_APPLICATION) || userRoles.includes(configData.ROLE_ATHLETE) || userRoles.includes(configData.ROLE_AGENT) || userRoles.includes(configData.ROLE_SCOUT)) {
    content = <ViewUserProfile uid={uid} totalamount={totalamount} userLoggedInRoles={userLoggedInRoles}/>;
  }  else {
    content = <p></p>;
  } */

  const introEmails = [
  { name: "Welcome Email", code: "W01", parent: "" },
  { name: "Getting Started", code: "G01", parent: "General" },
  { name: "Agent Intro", code: "A01", parent: "Agent" },
  { name: "Agent Follow Up", code: "A02", parent: "Agent" },
  { name: "Scout Intro", code: "S01", parent: "Scout" }
];
// const groupedEmails = introEmails.reduce((acc, item) => {
//   const parent = item.parent || "Others";

//   if (!acc[parent]) {
//     acc[parent] = [];
//   }

//   acc[parent].push(item);
//   return acc;
// }, {});
const groupedEmails = {};
const ungroupedEmails = [];

introEmails.forEach((item) => {
  if (!item.parent) {
    ungroupedEmails.push(item); // standalone
  } else {
    if (!groupedEmails[item.parent]) {
      groupedEmails[item.parent] = [];
    }
    groupedEmails[item.parent].push(item);
  }
});

const [openIndex, setOpenIndex] = useState(null);

const toggleAccordion = (index) => {
  setOpenIndex(openIndex === index ? null : index);
};


  const [activeView, setActiveView] = useState("view");

  useEffect(() => {
    if (location.pathname.includes("/edit")) {
      setActiveView("edit");
    } else {
      setActiveView("view");
    }
  }, [location.pathname]);

  const isViewingOwnProfile = loggedin_drupal_uid == uid;
  const isAdmin = userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
                  userLoggedInRoles.includes(configData.ROLE_SAADMIN);



const isEditPage = location.pathname.includes("/edit");
const isApplicationUser = userRoles.includes(configData.ROLE_APPLICATION);

const isMainDomain = mainDomains.includes(domainName);

const isOwnProfile = loggedin_drupal_uid == uid;

const isUserAuthorized =
  userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
  userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
  userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE);

// override ONLY edit tab behavior
// const renderToggle = 
//   // isApplicationUser && !isUserAuthorized && toggle === 2 ? 1 : toggle;
//   // !isUserAuthorized && toggle === 2 ? 1 : toggle;
//   (isMainDomain || !isUserAuthorized) && toggle === 2 ? 1 : toggle;
const renderToggle =
  toggle === 2 &&
  (
    // admin editing someone else's profile
    (isUserAuthorized && !isOwnProfile) ||

    // common user in main domain
    (!isUserAuthorized && isMainDomain)
  )
    ? 1
    : toggle;

  const handleOpenSortflagModal = () => {
    setIsSortFlagModalOpen(true);
  };
 
    const handleModalClose = (modalname) => {
        if(modalname == 'sortflag') {
        setIsSortFlagModalOpen(false); 
        }
        if(modalname == 'intro_email') {
        setShowIntroEmailModal(false);
        }
        
    };
  const formatResult = (item) => {
    return (
      <>
        
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </>
    )
  }
  
   const doBackAway = () => {
  
    if (window.history.length > 1) {
        navigate(-1); // Go back
    } else {
        navigate('/'); // Fallback to home
    }
  };
  const showView = () => {
    const newView = activeView === "view" ? "edit" : "view";
    setActiveView(newView);

    navigate(`/user/${uid}/${newView}`);
  };

 const handleOpen = () => {
    setSortflagValue();

  };
   const handleOnSortflagSelect = (item) => {
    // the item selected
    setSortflagValue(item.id);
  }
  const handleSortflagSubmit = async event => {
    event.preventDefault();
    
      const postData = {
        tid:sortflagValue,
        uid:drupalUID
      };
      const response = await fetch(app_url + 'sortflag/addsortflag', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
              
               setIsSortFlagModalOpen(false); 
               window.location.reload();
        } else {
            alert(data.data.text);
        }
       
    
  };
  const handleAgentInvite = async () => {
    
    
      const postData = {
        uid:drupalUID
      };
      const response = await fetch(app_url + 'smwwagency/agentinvite', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
        
              //setSuccess(data.data.result);
              localStorage.setItem("invitesuccessMessage", data.data.result);
              window.location.href = "/user/"+drupalUID;
        }
       
    
  };
  const handleScoutInvite = async () => {
    
    
      const postData = {
        uid:drupalUID
      };
      const response = await fetch(app_url + 'smwwscout/scoutinvite', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
        
              //setSuccess(data.data.result);
              localStorage.setItem("invitesuccessMessage", data.data.result);
              window.location.href = "/user/"+drupalUID;
        }
       
    
  };
  function updateToggle(id){
    setToggle(id);
    
    if(id == 1) { 
      //navigate("/users/"+userSlug,{state:uid});
      window.location.href = "/user/"+drupalUID;
    }
    if(id == 2) { 
      navigate("/user/"+drupalUID+"/edit");
    }
    if(id == 3) navigate("/user/"+drupalUID+"/my_orders");
    if(id == 4) { 
      navigate("/user/"+drupalUID+"/myreferral");
    }
    if(id == 8) navigate("/user/"+drupalUID+"/certificate");
    if(id == 7) navigate("/user/"+drupalUID+"/mentor");
    if(id == 6) navigate("/user/"+drupalUID+"/agent");
    if(id == 5) navigate("/user/"+drupalUID+"/scout");
    if(id == 9) navigate("/user/"+drupalUID+"/ambassador");
    if(id == 10) navigate("/user/"+drupalUID+"/athlete");
  }
  useEffect(() => {
    if (!authorized && tab !== 'certificate') {
        return;
    }

    Promise.all([
      retrieveUserProfileDetails(),
    // retrieveUserOrderDetails(),
    retrieveUserCertificateDetails(),
    retrieveSortFlags(),
    retrieveIntroEmails(),
    getDocTalkList()
    ]).then(() => {
     
      setIsLoading(false);
      if(tab == "my_orders") {
      setToggle(3);

    }
    if(tab == "edit") {
      setToggle(2);
    }
    if(tab == "myreferral") {
      setToggle(4);

    }
    if(tab == "scout" || tab == "edit_scout") {
      setToggle(5);
    }
    if(tab == "agent" || tab == "edit_agent") {
      setToggle(6);
    }
    if(tab == "certificate") {
      setToggle(8);
       //window.location.href = loggedin_domain+"/user/"+drupalUID+"/certificate";
    }
    if(tab == "mentor" || tab == "edit_mentor") {
      setToggle(7);
    }
     if(tab == "ambassador" || tab == "edit_ambassador") {
      setToggle(9);
    }
    if(tab == "athlete" || tab == "edit_athlete") {
      setToggle(10);
    }
    });
    
    
  },[]);
  
  async function retrieveUserDetailsByUsername() {
    
    if(username) {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getuserdetailsbyusername?username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      
     
      setTotalAmount(responsedata.data.total_amount_paid);
      setDrupalUID(responsedata.data.user.drupal_uid);
     
      if(location.pathname.indexOf("user") > -1) {
        if(tab != "my_orders" && tab != 'edit' && tab != 'myreferral') {
        navigate("/users/"+responsedata.data.user_slug,{state:responsedata.data.user.drupal_uid});
        }
      }
     
       if(responsedata.data.logged_in_user_roles) {
          setUserLoggedInRoles(responsedata.data.logged_in_user_roles)
       }
      
      setUserSlug(responsedata.data.user_slug);
    }
     }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
           
          }
  }
  }
   async function retrieveUserProfileDetails() {
    
    if(uid!='' || username!='') {
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getuserprofiledetails?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      uid = responsedata.data.user.drupal_uid;
      if(responsedata.data.date_of_app) responsedata.data.user.date_of_app = responsedata.data.date_of_app;
      setUserDetails(responsedata.data.user);
      setTotalAmount(responsedata.data.total_amount_paid);
      // setProductCount(responsedata.data.product_count)
      setDrupalUID(responsedata.data.user.drupal_uid);
      setUserLoggedinDetails(responsedata.data.logged_in_user);
     
      // setUserAssets(responsedata.data.user_assets);
      // setUserAthleteAssets(responsedata.data.user_athlete_assets);
      // setUserDocTalkAssets(responsedata.data.user_doctalk_assets);
        // setUserMentorAssets(responsedata.data.user_mentor_assets);
      // setUserEventAssets(responsedata.data.user_event_attendee_assets);
      //  setUserAgentAssets(responsedata.data.user_agent_assets);
      //  setUserScoutAssets(responsedata.data.user_scout_assets)
      //  setUserAmbassadorAssets(responsedata.data.user_ambassador_assets);
       setUserCommonAssets(responsedata.data.user_common_assets);
      //  setUserLeadAssets(responsedata.data.user_lead_assets);
      //  setUserSocailMediaAssets(responsedata.data.social_media_assets);
      // setUserSortflags(responsedata.data.user_sort_flags);
      // setAgentScoutStatus(responsedata.data.agent_scout_status);
      if(responsedata.data.user_roles) {
        setUserRoles(responsedata.data.user_roles);
      }
      if(responsedata.data.logged_in_user_roles) {
        setUserLoggedInRoles(responsedata.data.logged_in_user_roles)
      }
      setUserSlug(responsedata.data.user_slug);
      if(location.pathname.indexOf("user/") > -1) {
       
        if(tab != "my_orders" && tab != 'edit' && tab != 'myreferral') {
          navigate("/users/"+responsedata.data.user_slug,{state:{userId: responsedata.data.user.drupal_uid}});
        }
      } else {
      navigate("/users/"+responsedata.data.user_slug,{state:{userId: responsedata.data.user.drupal_uid}});
      }
    }
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            
          }
  }
  }
  async function retrieveUserCertificateDetails() {
    
    if(drupalUID && !Number.isNaN(drupalUID)) {
    const response = await fetch(
      app_url+'certificate/getcertificatelist?uid='+uid+'&username='+username,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
      setCertificateCount(responsedata.data.count);
    }
  }
  }
  // async function retrieveUserOrderDetails() {
  //   if(drupalUID) {
  //   const response = await fetch(
  //     app_url+'myorder/getuserorderdetails?uid='+uid+'&username='+username,
  //     {
  //       method: "GET",
  
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     }
  //   )
  //   const responsedata = await response.json();
  //   if(responsedata.data) {
  //   setUserOrderDetails(responsedata.data); 
  //   console.log("test");
  //   } 
  // }
  // }
  async function  retrieveSortFlags() {
    
    if(drupalUID && !Number.isNaN(drupalUID)) {
    const response = await fetch(
      app_url+'sortflag/getnewsortflaglist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagList(responsedata.data.result);
    }
  }
  }
   async function retrieveIntroEmails() {
    
    if(drupalUID && !Number.isNaN(drupalUID)) {
       try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'emails/getintroemaillist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setIntroEmails(responsedata.data.result);
      
    }
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            
          }
  }
  }

  const handleIntroEmailModalOpen = async (code,name) => {
    
    setShowIntroEmailModal(true);
      if(drupalUID && !Number.isNaN(drupalUID)) {
        try {
          const response =  await fetch(
          app_url+'emails/getintroemaildetailedview?uid='+drupalUID+'&code='+code,
          {
            method: "GET",
  
            headers: {
              'Content-Type': 'application/json',
            },
          }
          )
          const responsedata =  await response.json();
                
          if(responsedata.data.msg == "Success") {
            //setIntroEmailDetailedView(responsedata.data.result);
            setFormIntroEmailData({
                email:responsedata.data.result.email,
                subject:responsedata.data.result.subject,
                name:responsedata.data.result.name,
                drupal_uid:responsedata.data.result.drupal_uid,
                body:responsedata.data.result.body,
                loggedin_user_email:responsedata.data.result.loggedin_user_email,
                loggedin_user_name:responsedata.data.result.loggedin_user_name,
                course_code:name
            });
           
            } 
          } catch (err) {
            }
      }
        
   };
    const handleImpersonate = async (drupalUID) => {
    
   
      if(drupalUID && !Number.isNaN(drupalUID)) {
        try {
          setIsLoading(true);
          const response =  await fetch(
          app_url+'site/impersonateuser?uid='+drupalUID,
          {
            method: "GET",
  
            headers: {
              'Content-Type': 'application/json',
            },
          }
          )
          const responsedata =  await response.json();
                
          if(responsedata.data.msg == "Success") {
            window.location.reload();
            } 
          } catch (err) {
            }finally {
            setIsLoading(false);
          }
      }
        
   };
   const handleIntroEmailSubmit = async event => {
    event.preventDefault();
    
      const response = await fetch(app_url + 'emails/sendintroemail', {
        method: 'POST',
        body: JSON.stringify(formIntroEmailData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
               
               setShowIntroEmailModal(false); 
               window.location.reload();
               
        } else {
          alert("Error!");
        }
       
    
  };

  async function getDocTalkList() {
    if(drupalUID && !Number.isNaN(drupalUID)) {
        
         try {
            const response = await fetch(
                app_url+'doctalk/getdoctalklist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setDocTalks(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }

  const handleButtonClick = async () => {
    const next = !openDOC;
    setOpenDOC(next);
    setSearch("");

    if (next && docTalks.length === 0) {
      getDocTalkList();
    }
  };

  const handleSelect = async (docTalk) => {
    try {
     
      const postData = {
           doctalknid: docTalk.value,
           drupal_uid:drupalUID
          };
          try {
            const response = await fetch(app_url + 'doctalk/addusertodoctalk', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert(`${docTalk.label} added successfully`);
               window.location.reload();
              setOpenDOC(false);
              setSearch("");
            }
          } catch (err) {
            
        }
      
      
    } catch (err) {
      console.error(err);
    }
  };

  const filtered = docTalks.filter((item) =>
    item.label?.toLowerCase().includes(search.toLowerCase())
  );

const dropdownRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDOC(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
 
  return (
   <>
   {isLoading ? (
        <Loading />
      ) : (
    <div id="main">
 
      <div class="left"></div>

      <div className={`left-center view-profile-wrapper ${toggle == 8 ? "certificate-center" : "center"}`}>
        <Helmet>
          <title>{userDetails.email}</title>
        </Helmet> 
         {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        {success && (
                          <><br></br>
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                        </div></>
                        )}
     {loggedin_uid && !Number.isNaN(loggedin_uid) && (
      <>
  {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
    userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
    userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || drupal_uid == uid ) ? (
      <><h2 class="element-invisible">Primary tabs</h2>
      <ul class="tabs view-tab-primarya">
        <li className= {renderToggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>App<span class="element-invisible">(active tab)</span></a></li>
        {userRoles.includes(configData.ROLE_AGENT) && (
        <li className= {renderToggle === 6? "active" : ""} onClick={()=> updateToggle(6)}><a>Agent</a></li>
        )}
        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
          userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
          userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (userRoles.includes(configData.ROLE_GLOBAL_AMBASSADOR)) && (
        <li className= {renderToggle === 9? "active" : ""} onClick={()=> updateToggle(9)}><a>Ambassador</a></li>
        )}
        {userRoles.includes(configData.ROLE_MENTOR) && (
        <li className= {renderToggle === 7? "active" : ""} onClick={()=> updateToggle(7)}><a>Mentor</a></li>
        )}
        {(((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
        && loggedin_drupal_uid == uid) || (!mainDomains.includes(domainName) && loggedin_drupal_uid == uid)) && (
        <li className= {renderToggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit Profile</a></li>
        )}
         {userRoles.includes(configData.ROLE_SCOUT) && (
        <li className= {renderToggle === 5? "active" : ""} onClick={()=> updateToggle(5)}><a>Scout</a></li>
        )}
        {userRoles.includes(configData.ROLE_ATHLETE) && (
        <li className= {renderToggle === 10? "active" : ""} onClick={()=> updateToggle(10)}><a>Athlete</a></li>
        )}
        <li className= {renderToggle === 3? "active" : ""} onClick={()=> updateToggle(3)}><a>My Orders</a></li>
        <li className= {renderToggle === 4? "active" : ""} onClick={()=> updateToggle(4)}><a>My Referral Wallet</a></li>
        {certificateCount > 0 && (
        <li className= {renderToggle === 8? "active" : ""} onClick={()=> updateToggle(8)}><a>My Credentials</a></li>
        )}
      </ul></>  
    ) : (
      <></>
    )}  
    </>
      )}
      {renderToggle === 1 && (
      <div  className= {renderToggle === 1? "show-content" : "content"} style={userCommonAssets.field_dormant === 1 ? { backgroundColor: '#63686e',color:'#fff',padding:'8px' } : {}}>
        <div class="profile" typeof="sioc:UserAccount" >
          {/* {(userRoles.includes(configData.ROLE_SALES_PEOPLE) && domainName !== configData.RSMWW_AGENCY_DOMAIN && loggedin_drupal_uid == uid) && (
          // <><div class="domain-alert">Trying to access your SMWW Agency account? <a href={"/user/"+loggedin_drupal_uid} target="_blank">Click here</a>.</div></>
          <><div class="domain-alert">Trying to access your SMWW Agency account? <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/users/"+username} target="_blank">Click here</a>.</div></>
          
          )} */}
            {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
          && loggedin_drupal_uid == uid) && (
              <div className='viewtab-top-section' >
            <div style={{paddingTop: "10px"}}>
          {((userLoggedInRoles.includes(configData.ROLE_AGENT) && !agencyDomains.includes(domainName) && loggedin_drupal_uid == uid) &&
          !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) && ( 
            <div className='domain-alert'>
              Trying to access your SMWW Agency account? 
              <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/user/"+loggedin_drupal_uid} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
            </div>
          )}
          {((userLoggedInRoles.includes(configData.ROLE_SCOUT) && !scoutDomains.includes(domainName) && loggedin_drupal_uid == uid) &&
          !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) && ( 
            <div className='domain-alert'>
              Trying to access your SMWW Scout account? 
              <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/user/"+loggedin_drupal_uid} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
            </div>
          )}
          {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
          (userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && 
          !((userLoggedInRoles.includes(configData.ROLE_AGENT) && agencyDomains.includes(domainName)) || 
          (userLoggedInRoles.includes(configData.ROLE_SCOUT) && scoutDomains.includes(domainName))))) && (
          <><div className="user-profile-buttons">
  
            <div className="actions-row-1">
            {userRoles.includes(configData.ROLE_APPLICATION) && 
            <>
            {loggedin_drupal_uid != uid && (
            <><a href style={{cursor:'pointer'}} class="masquerade-switch" onClick={() => handleImpersonate(drupalUID)}>Impersonate this user</a></>
            )}
            <input type="button" name="send_agent_invite" id="send_agent_invite" value="Send Agent Invite" onClick={() => handleAgentInvite()}/>
          <input type="button" name="send_scout_invite" id="send_scout_invite" value="Send Scout Invite" onClick={() => handleScoutInvite()}/></>} 

<div className='doc-talk-block-dropdown'>
            <Box ref={dropdownRef} sx={{ position: "relative", display: ["-webkit-inline-flex", "inline-flex"] }}>
              {/* BUTTON */}
              <Button 
                variant="contained" 
                onClick={handleButtonClick}
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #bbb",
                  borderRadius: "2px",
                  color: "#111",
                  fontSize: "12px",
                  fontWeight: "400",
                  marginRight: "9px",
                  marginTop: "5px",
                  padding: "5px 8px",
                  boxShadow: "none",
                  lineHeight: "1.2",
                  textTransform: "none",
                  fontFamily: "inherit",
                  "&:hover": {
                    backgroundColor: "#ccc",
                  },
                }}
              >
                Add to DOC Talk
              </Button>

              {/* DROPDOWN */}
              {openDOC && (
                <Box
                  className="doc-talk-dropdown"
                  sx={{
                    position: "absolute",
                    top: 40,
                    width: 300,
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    background: "#fff",
                    zIndex: 999,
                    boxShadow: 3,
                  }}
                >
                  {/* SEARCH INSIDE DROPDOWN */}
                  <Box sx={{ p: 1 }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search Doc Talk..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Box>

                  {/* OPTIONS */}
                  <Box sx={{ maxHeight: 250, overflowY: "auto" }}>
                    {filtered.length > 0 ? (
                      filtered.map((item) => (
                        <Box
                          key={item.value}
                          onClick={() => handleSelect(item)}
                          sx={{
                            p: 1,
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                        >
                          {item.label}
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ p: 1, color: "gray" }}>No results found</Box>
                    )}
                  </Box>
                </Box>
              )}
            </Box>

          {userRoles.includes(configData.ROLE_APPLICATION) && 
            <><a href={'/add_to_earena/'+drupalUID} target="_blank"><input type="button" name="add_to_earena" id="add_to_earena" value="Add to E-Arena"/></a></>} 
</div>

          </div>

          {!userRoles.includes(configData.ROLE_APPLICATION) && <input type="button" name="add_sortflag" id="add_sortflag" value="Add SortFlag" onClick={() => handleOpenSortflagModal()}/>}
           {/* {((userRoles.includes(configData.ROLE_ADMINISTRATOR) || userRoles.includes(configData.ROLE_SAADMIN) || userRoles.includes(configData.ROLE_SALES_PEOPLE))
          && loggedin_drupal_uid == uid) && <div className="actions-row-2"><button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button></div>} */}
          </div>
          </>
          
          )}
          <div style={{padding: "10px 18px"}}>
          {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
            <>
          {/* {(domainName != configData.RSMWW_AGENCY_DOMAIN && domainName != configData.RSMWW_SCOUT_DOMAIN) ? ( */}
           {/* {!(
            (userLoggedInRoles.includes(configData.ROLE_AGENT) &&
              domainName === configData.RSMWW_AGENCY_DOMAIN) ||
            (userLoggedInRoles.includes(configData.ROLE_SCOUT) &&
              domainName === configData.RSMWW_SCOUT_DOMAIN)
          ) && ( */}
          {!(
            (
              userLoggedInRoles.includes(configData.ROLE_AGENT) &&
              !((userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid != uid) || 
              userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
              userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
              agencyDomains.includes(domainName)
            ) ||
            (
              userLoggedInRoles.includes(configData.ROLE_SCOUT) &&
              !((userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid != uid) || 
              userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
              userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
              scoutDomains.includes(domainName)
            )
          ) && (
          <>
          {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
          userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) || userRoles.includes(configData.ROLE_MENTOR) || (loggedin_drupal_uid == uid)) && (
          <div><div class="user-image" style={{ marginRight: '2%' }}>
          {userDetails.picture ? (  
            <><img  src={userDetails.picture} width="100px" height="100px" alt = "user"/></>
          ):(
            <><img  src={domain_url+"pictures/notavailable.jpg"} width="100px" height="100px" alt = "user"/></>
          )}
           </div>
           
          <div class="user-name-loc" style={{marginBottom:'2%'}}>
            <span class="user-name" style={{color:"#333333"}}>{userDetails.first_name} {userDetails.last_name}</span>
             {userRoles.includes(configData.ROLE_MENTOR) && (
              <><span class="user-name" style={{marginBottom:"5px",fontSize:'16px'}}>{userCommonAssets.field_mentor_title}</span></>
             )}
            <span class="user-loc" style={{marginBottom:"5px",fontSize:"13px",color:"#666666"}}>{userDetails.city && userDetails.city+', '} 
              {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</span>
              {!userRoles.includes(configData.ROLE_MENTOR) && (
                <span style={{ backgroundColor: '#FFFF00', padding: '2px 8px', color: '#333333',fontSize:"13px",width:"167px" }}><strong>Recent app: {userCommonAssets.field_date_of_app}</strong></span>
              )}
          </div>
          <div className='user-media-clear-both'></div>
          </div>
           )}
           {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) || (loggedin_drupal_uid == uid)) && (
            <div className='profile-right'>
          <div class="user_total_amount" style={{ float: 'right', fontWeight: 'bold'}}>Total Purchased: ${totalamount}</div>
          </div> 
           )}
           </>
          )}
          {/* ):(
            <></>
          )} */}
          </>) : (<></>)}</div>
              {userRoles.includes(configData.ROLE_MENTOR) && (
           <div style={{textAlign:'right', marginRight: "2%"}}><a href="javascript:void(0);" onClick={doBackAway}>« Back</a></div>
              )}
              <div style={{clear: "both"}}></div>
              </div></div>)}
        </div>
        <div className="dashboard-content">
            {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && loggedin_drupal_uid == uid) ? (
               <ViewSaadminDashboard userLoggedInRoles={userLoggedInRoles}/>
            ) :
            (userLoggedInRoles.includes(configData.ROLE_SAADMIN) && loggedin_drupal_uid == uid) ? (
               <ViewSaadminDashboard userLoggedInRoles={userLoggedInRoles}/>
            ) : ((userLoggedInRoles.includes(configData.ROLE_AGENT)) && 
            agencyDomains.includes(domainName) && loggedin_drupal_uid == uid) ? (
            <>
            {/* {(userLoggedInRoles.includes(configData.ROLE_SCOUT)) && ( 
              <div className='domain-alert'>
                Trying to access your SMWW Scout account? 
                <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/users/"+username} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
              </div>
            )} */}
              <AgentHome userLoggedInRoles={userLoggedInRoles} uid={drupalUID} />
            </>
            ) : ((userLoggedInRoles.includes(configData.ROLE_SCOUT)) && 
            scoutDomains.includes(domainName) && loggedin_drupal_uid == uid) ? (
              <>
                {/* {(userLoggedInRoles.includes(configData.ROLE_AGENT)) && ( 
                  <div className='domain-alert'>
                    Trying to access your SMWW Agency account? 
                    <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/users/"+username} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
                  </div>
                )} */}
                  <ScoutHome userLoggedInRoles={userLoggedInRoles} uid={drupalUID} />
              </>
            ) : 
            (userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) && loggedin_drupal_uid == uid) ? (
              <ViewSalespersonDashboard />
            ) : 
          //   (userRoles.includes(configData.ROLE_APPLICATION)) ? (
          // <ViewApplicationProfile uid={drupalUID} username={username} userLoggedinDetails={userLoggedinDetails} userLoggedInRoles={userLoggedInRoles} userLeadAssets = {userLeadAssets}   userEventAssets = {userEventAssets} userDoctalkAssets = {userDoctalkAssets} userRoles={userRoles} />
          // ):
      //     (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || (loggedin_drupal_uid == uid)) ? (
      //  <ViewUserProfile uid={drupalUID} totalamount={totalamount} userLoggedinDetails={userLoggedinDetails} userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} userAssets={userAssets} 
      //  userAthleteAssets={userAthleteAssets} userMentorAssets={userMentorAssets} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAmbassadorAssets={userAmbassadorAssets} 
      //  userCommonAssets={userCommonAssets} userLeadAssets = {userLeadAssets}   userEventAssets = {userEventAssets} userDoctalkAssets = {userDoctalkAssets} userSortflags={userSortflags} userRoles={userRoles} 
      //  productCount={productCount} agentscoutstatus={agentscoutstatus}/>
      // ) :
      (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || (loggedin_drupal_uid == uid)) ? (
      <ViewApplicationProfile  uid={drupalUID} username={username} userLoggedinDetails={userLoggedinDetails} userLoggedInRoles={userLoggedInRoles} userRoles={userRoles} />
      ) :
      (userRoles.includes(configData.ROLE_MENTOR) ? (
          <><div dangerouslySetInnerHTML={{ __html: userCommonAssets.field_biography }}></div></>
         ) : (
          <>You are not authorized</>
         )
        
      )
    }
      </div>
       
         
      </div>
   )}
   {renderToggle === 6 && (
      <div  className= {renderToggle === 6? "show-content" : "content"}>
        {/* <EditAgent uid={drupalUID}  userLoggedInRoles={userLoggedInRoles} userAgentAssets={userAgentAssets} userSocailMediaAssets={userSocailMediaAssets} userDetails={userDetails} userCommonAssets={userCommonAssets}/> */}
        <ViewAgentProfile uid={drupalUID}  userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} />
      </div>)}
      {renderToggle === 9 && (
       <div  className= {renderToggle === 9? "show-content" : "content"}>
        {/* <EditAmbassador uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userSocailMediaAssets={userSocailMediaAssets} picture={userDetails.picture} userAmbassadorAssets={userAmbassadorAssets} userCommonAssets={userCommonAssets}/> */}
        <ViewAmbassadorProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} />
      </div>)}
      {renderToggle === 7 && (
      <div  className= {renderToggle === 7? "show-content" : "content"}>
        {/* <EditMentor uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userMentorAssets={userMentorAssets}/> */}
        <ViewMentorProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} />

      </div>)}
      {renderToggle === 2 && (
      <div  className= {renderToggle === 2? "show-content" : "content"}>
        {/* <EditProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userRoles={userRoles} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAthleteAssets={userAthleteAssets} userAmbassadorAssets={userAmbassadorAssets} userLeadAssets = {userLeadAssets} userMentorAssets={userMentorAssets} userEventAssets = {userEventAssets}/> */}
        {(((userRoles.includes(configData.ROLE_ADMINISTRATOR) || userRoles.includes(configData.ROLE_SAADMIN) || userRoles.includes(configData.ROLE_SALES_PEOPLE))
        && loggedin_drupal_uid == uid) || 
        (!mainDomains.includes(domainName) && loggedin_drupal_uid == uid)) &&
        <>
        {/* {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR))) ? (
          <AdminEditProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} picture={userDetails.picture} userRoles={userRoles} userDoctalkAssets = {userDoctalkAssets} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAthleteAssets={userAthleteAssets} userAmbassadorAssets={userAmbassadorAssets} userLeadAssets = {userLeadAssets} userMentorAssets={userMentorAssets} userEventAssets = {userEventAssets}/>
        ) : (
          <EditProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userRoles={userRoles} userDoctalkAssets = {userDoctalkAssets} userAgentAssets={userAgentAssets} userScoutAssets={userScoutAssets} userAthleteAssets={userAthleteAssets} userAmbassadorAssets={userAmbassadorAssets} userLeadAssets = {userLeadAssets} userMentorAssets={userMentorAssets} userEventAssets = {userEventAssets}/>
        )} */}
        {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ? (
        <ApplicantAdminEditProfile uid={drupalUID} username={username} userLoggedInRoles={userLoggedInRoles} picture={userDetails.picture} userRoles={userRoles}/>
        ) : (
        <ApplicantSAAdminEditProfile uid={drupalUID} username={username} userLoggedInRoles={userLoggedInRoles} picture={userDetails.picture} userRoles={userRoles} />
        )}
        </>}
      </div>)}
      {renderToggle === 5 && (
      <div  className= {renderToggle === 5? "show-content" : "content"}>
        {/* <EditScout uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userScoutAssets={userScoutAssets}/> */}
        <ViewScoutProfile uid={drupalUID} userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} />
      </div>)}
      {renderToggle === 10 && (
      <div  className= {renderToggle === 10? "show-content" : "content"}>
        <ViewAthleteProfile uid={drupalUID} username={username}  userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} />
      </div>)}
      {renderToggle === 3 && (
      <div  className= {renderToggle === 3? "show-content" : "content"}>
        <OrderPage userUid={drupalUID} username={username} userLoggedInRoles={userLoggedInRoles}/>
      </div>)}
      {renderToggle === 4 && (
      <div  className= {renderToggle === 4? "show-content" : "content"}>
        <ReferralPage uid={drupalUID} userLoggedInRoles={userLoggedInRoles}/>
      </div>)}
      {renderToggle === 8 && (
      <div  className= {renderToggle === 8? "show-content" : "content"}>
        <CertificatePage uid={drupalUID} userDetails={userDetails}/>
      </div>)}

      {IsSortFlagModalOpen && (
        <>
         <div className="ad-modal-overlay add-sortflag">
                    <div className="ad-modal">
                        <button className="adm-close-button" onClick={() => handleModalClose('sortflag')}>×</button>
                        
                        <h2>Add Sortflag</h2>
                        <hr/>
                        <form className='ad-modal-form'>
                          <table>
                            <tr><td>
                           <label>Sortflags:</label></td>
                           <td> <div className="auto-complete">
                            {/* <ReactSearchAutocomplete
            items={sortflagList}
            
            onSelect={handleOnSortflagSelect}
           formatResult={formatResult} 
            autoFocus
            resultsContainerStyle={{
    width: '100%', // Adjust width as needed
  }}
          />*/}
           <Select 
                    
                    id="sortflag" name="sortflag" 
                    searchable={true}
                    required={true}  
                    clearable={true} 
                    clearOnBlur={true} 
                    clearOnSelect={true}
                    backspaceDelete={true} 
                     isOpen={true}
                    
                    style={{backgroundColor:'#ffffff', width:'87.8%', borderRadius: 5}}
                                        
                    options={sortflagList} 
                    onChange={(val) => {
                      if(val.length == 0) {
                        console.log(val);
                      }
                      else{
                        setSortflagValue(val[0]['value']);
                     
                      
                      }}
                    }
                    onDropdownOpen={handleOpen}
                    
                    
                    />
          </div>
                            </td>
                          </tr>
                          <tr><td></td><td align="right"><button type="submit" onClick={handleSortflagSubmit}>Submit</button></td></tr></table>
                       
                        </form>
                    </div>
                </div>
       </>
      )}
      {showIntroEmailModal && (           
<div id="myModal" class="modal intro-email-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('intro_email')}>&times;</span>
      <button type="button" className="sendemailIntroBtn" style={{float: "right"}} onClick={handleIntroEmailSubmit} role="button"><span class="ui-button-text">Send Email</span></button>
      <h2>Send Mail</h2>      
    </div>
    <div class="modal-body">      
        <form className="form_sendmail" id="form_sendMail" method="post">
        
        <p class="course-details">Course Details: <strong>{formIntroEmailData.course_code}</strong> </p>
        <div class="form-group">
            <label>Name: </label>
            <span class="input-firstname">{formIntroEmailData.name}</span>
        </div>
        <div class="form-group">
            <label>Application's Email: </label>
            <span class="input-email">{formIntroEmailData.email}</span>
        </div>
        <div class="form-group">
          <label>From Address: </label>
            <input class="form-control" id="drip-sal" name="salutation" type="text" value={formIntroEmailData.loggedin_user_email+', '+formIntroEmailData.loggedin_user_name}/>
        </div>
		<div class="form-group">
   <label>Email Content: </label>
           
       <Editor value={formIntroEmailData.body} onChange={(e) =>
                                           setFormIntroEmailData((prev) => ({ ...prev, body: e.target.value }))
   }>
        <Toolbar>
            <BtnBold />
            <BtnItalic />
            <BtnUndo/>   
            <BtnRedo/>                                                
        </Toolbar>
      </Editor>
                                          
 </div>

	</form>
    </div>
    {/* <div class="modal-footer">
     <button type="button" className="sendemailIntroBtn" onClick={handleIntroEmailSubmit} role="button"><span class="ui-button-text">Send Email</span></button>
    </div> */}
  </div>

</div>
  )}
    </div>

    

{/* {!hiddenPaths.includes(currentPath) && ( */}
{toggle !== 8 && (
<div class="right view-tab-right">
 
  {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) )) ? (
    <>
      <SalespersonSidebar />
      {userRoles.includes(configData.ROLE_APPLICATION) && (
        <>
      {(!excludedtoggle.includes(toggle) && activeView === "view") && (
      <div className="intro_emails"><h1>Send Email</h1>
      {/* {introemails.map((item, index) => {

    
    if (item.name) {
      return (
        <li key={index}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleIntroEmailModalOpen(item.code, item.name);
            }}
          >
            {item.name}
          </a>
        </li>
      );
    }

  
    const groupName = Object.keys(item)[0];
    const groupItems = item[groupName];

    return (
      <li key={index}>
        <strong>{groupName}</strong>
        <ul style={{ paddingLeft: "15px" }}>
          {groupItems.map((subItem, i) => (
            <li key={i}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleIntroEmailModalOpen(subItem.code, subItem.name);
                }}
              >
                {subItem.name}
              </a>
            </li>
          ))}
        </ul>
      </li>
    );
  })} */}

<div className='salesperson-activity-graph-wrapper' style={{padding: "0"}}>
{/* Ungrouped items first */}
<div className='intro-email-sep'>
  {ungrouped.map((item, index) => (
    <li key={`ungrouped-${index}`}>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleIntroEmailModalOpen(item.code, item.name);
        }}
      >
        {item.name}
      </a>
    </li>
  ))}
</div>
{/* Grouped items next */}
{grouped.map((item, index) => {
  const groupName = Object.keys(item)[0];
  const groupItems = item[groupName];
 const isSingleItem = groupItems.length === 1;

  return (
    <div className="accordion" key={`group-${index}`}>
      <li className="accordion-item">
        <div
          className="accordion-header"
         onClick={() => {
            if (isSingleItem) {
              // directly open modal
              handleIntroEmailModalOpen(
                groupItems[0].code,
                groupItems[0].name
              );
            } else {
              // normal accordion toggle
              toggleAccordion(index);
            }
          }}
        >
          <strong>{groupName}</strong>&nbsp;
          {!isSingleItem && (
          <span
            style={{
              display: "inline-block",
              float: "right",
              fontSize: "11px",
              color: "#999",
              transition: "transform 0.2s",
              transform:
                openIndex === index ? "rotate(90deg)" : "rotate(0deg)",
            }}
          >
            ▶
          </span>
          )}
        </div>

        {openIndex === index && (
          <ul style={{ paddingLeft: "15px" }} className="accordion-body">
            {groupItems.map((subItem, i) => (
              <li key={i}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleIntroEmailModalOpen(
                      subItem.code,
                      subItem.name
                    );
                  }}
                >
                  {subItem.name}
                </a>
              </li>
            ))}
          </ul>
        )}
      </li>
    </div>
  );
})}
</div>
    {/* {ungroupedEmails.map((item) => (
      <div key={item.id}>                
        <a 
          href
          onClick={(e) => {
            e.preventDefault();
            handleIntroEmailModalOpen(item.code, item.name);
          }}
        >
          {item.name}
        </a>
        </div>
    ))}

{Object.keys(groupedEmails).length > 0 && (
  <div className="accordion">

    {Object.entries(groupedEmails).map(([parent, items], index) => (
      <div key={index} className="accordion-item admin-edit-profile-toggle">

        <div 
          className="accordion-header"
          onClick={() => toggleAccordion(index)}
        >
        <span
          style={{
            display: 'inline-block',
            transition: 'transform 0.2s',
            transform: openIndex === index ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
        >
          ▶
        </span> {parent}
        </div>

        {openIndex === index && (
          <ul className="accordion-body">
            {items.map((item, i) => (
              <li key={i}>
                <a 
                  href
                  onClick={(e) => {
                    e.preventDefault();
                    handleIntroEmailModalOpen(item.code, item.name);
                  }}
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        )}

      </div>
    ))}

  </div>
)} */}

        </div>
        )}
        </>
      )}
      </>
  ) : (userLoggedInRoles.includes(configData.ROLE_AGENT) && loggedin_drupal_uid == uid) ? (
      // <AgentBackendSidebar/>
      <SalespersonSidebar />
  ) : (userLoggedInRoles.includes(configData.ROLE_SCOUT) && loggedin_drupal_uid == uid) ? (
      // <ScoutSidebar/>
      <SalespersonSidebar />
  ) : (userLoggedInRoles.includes(configData.ROLE_APPLICATION) && (
              
                <>
   <div className="salesperson-right">
            <div id="sidebar-third" className="salesperson-grid_4">
                <div className="salesperson-region salesperson-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="salesperson-block salesperson-block-smww"></div>
                        <div>
                            <h1>Quick Links</h1>
                            <ul>
                                <li className='salesperson-header-hello-text'><a href={"/user/"+drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>          
                                {localStorage.getItem('masquerade') == 1 && (
                                    <li>
                                    <a className="salesperson-quick_link_anchor" href={`/miscellaneous/charge/${drupal_uid}`}>
                                        Miscellaneous Charge
                                    </a>
                                    </li>
                                )}
                             </ul>
                          </div>
                        </div>   
                        </div>
                        </div></>
             )
             )}
</div>
 )}
  <div class="clear"></div> 
  
</div>
)}
    </>
    
    
  )
}

export default ViewTab